import { h } from "preact";

import { classNames } from "../helpers";
import Button from "./Button.jsx";
import CircleLoadingIndicator from "./CircleLoadingIndicator.jsx";
import Icon from "./Icon.jsx";

export default function SubmitButton({ children, success, sending, ...props }) {
  const classes = classNames(
    props.class,
    "submit-button",
    success && "submit-button--success",
    !sending && !success && "submit-button--noIcon"
  );

  return (
    <Button
      type="submit"
      disabled={success || sending}
      {...props}
      class={classes}
      iconFront={
        <span class="submit-button__icon">
          <CircleLoadingIndicator />
          <Icon>check</Icon>
        </span>
      }
    >
      {children}
    </Button>
  );
}
